(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inverawe-autumn-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  var link = event.target.closest('.inverawe-autumn-hero a[data-autumn-scroll]');
  if (!link) return;
  var hash = link.getAttribute('href');
  if (!hash || hash.charAt(0) !== '#') return;
  var target = document.getElementById(hash.slice(1));
  if (!target) return;
  if (target.querySelector('inverawe-mobile-products')) return;
  event.preventDefault();
  var heading = target.querySelector('h2');
  if (heading) {
    heading.setAttribute('tabindex', '-1');
    heading.focus({preventScroll: true});
  }
  window.scrollTo({
    top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 24),
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
  });
  window.history.replaceState(window.history.state, '', hash);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inverawe-christmas-tree"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.inverawe-christmas').forEach((section) => {
    const markers = section.querySelectorAll('[data-gift-target]');
    markers.forEach((marker) => {
      marker.addEventListener('click', () => {
        markers.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        });
        section.querySelectorAll('.inverawe-christmas__panel').forEach((panel) => panel.hidden = true);
        const panel = section.querySelector(`#${CSS.escape(marker.dataset.giftTarget)}`);
        if (panel) {
          panel.hidden = false;
          marker.classList.add('is-active');
          marker.setAttribute('aria-expanded', 'true');
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inverawe-fairytale-page"] && !Shopify.designMode) return;
  try {
    
  function initializeFairytale(root) {
    const sections = root.matches?.('.fairytale') ? [root] : root.querySelectorAll('.fairytale');
    sections.forEach((section) => {
    if (section.dataset.fairytaleReady) return;
    section.dataset.fairytaleReady = 'true';
    const hotspots = section.querySelectorAll('.fairytale__hotspot');
    const cards = section.querySelectorAll('.fairytale__card');
    const stage = section.querySelector('.fairytale__stage');
    const landscape = section.querySelector('.fairytale__landscape img');
    const header = section.querySelector('.fairytale__header');
    const updateHeader = () => {
      const compact = window.scrollY > 120;
      header.classList.toggle('is-compact', compact);
      section.classList.toggle('has-compact-header', compact);
    };
    const alignGifts = () => {
      if (!landscape || !stage || !landscape.naturalWidth || !stage.clientWidth || !stage.clientHeight) return;
      const width = landscape.clientWidth;
      const height = landscape.clientHeight;
      const stageBounds = stage.getBoundingClientRect();
      const imageBounds = landscape.getBoundingClientRect();
      const imageStyle = getComputedStyle(landscape);
      const scale = imageStyle.objectFit === 'contain'
        ? Math.min(width / landscape.naturalWidth, height / landscape.naturalHeight)
        : Math.max(width / landscape.naturalWidth, height / landscape.naturalHeight);
      const imageWidth = landscape.naturalWidth * scale;
      const imageHeight = landscape.naturalHeight * scale;
      const position = imageStyle.objectPosition.split(' ').map(value => parseFloat(value) / 100);
      const offsetX = imageBounds.left - stageBounds.left + (width - imageWidth) * position[0];
      const offsetY = imageBounds.top - stageBounds.top + (height - imageHeight) * position[1];
      hotspots.forEach((hotspot) => {
        hotspot.style.setProperty('--x', `${offsetX + imageWidth * Number(hotspot.dataset.giftX) / 100}px`);
        hotspot.style.setProperty('--y', `${offsetY + imageHeight * Number(hotspot.dataset.giftY) / 100}px`);
        hotspot.style.setProperty('--gift-width', `${imageWidth * (Number(hotspot.dataset.giftWidth) || 7) / 100}px`);
        hotspot.style.setProperty('--gift-height', `${imageHeight * (Number(hotspot.dataset.giftHeight) || 10) / 100}px`);
      });
      section.dataset.giftsAligned = 'true';
    };
    const observer = new ResizeObserver(alignGifts);
    if (stage && landscape) {
      observer.observe(stage);
      observer.observe(landscape);
      landscape.addEventListener('load', alignGifts);
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    alignGifts();
    updateHeader();
    section.fairytaleCleanup = () => {
      observer.disconnect();
      landscape?.removeEventListener('load', alignGifts);
      window.removeEventListener('scroll', updateHeader);
    };
    section.querySelectorAll('[data-fairytale-target]').forEach((hotspot) => {
      hotspot.addEventListener('click', () => {
        const card = section.querySelector(`#${CSS.escape(hotspot.dataset.fairytaleTarget)}`);
        if (card) {
          hotspot.classList.add('is-active');
          hotspot.setAttribute('aria-expanded', 'true');
          card.showModal();
        }
      });
    });
    section.querySelectorAll('[data-fairytale-close]').forEach((button) => {
      button.addEventListener('click', () => button.closest('.fairytale__card').close());
    });
    cards.forEach((card) => {
      card.addEventListener('close', () => {
        const hotspot = section.querySelector(`[data-fairytale-target="${CSS.escape(card.id)}"]`);
        if (!hotspot) return;
        hotspot.classList.remove('is-active');
        hotspot.setAttribute('aria-expanded', 'false');
        hotspot.focus({ preventScroll: true });
      });
      card.addEventListener('click', (event) => {
        if (event.target !== card) return;
        const bounds = card.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) card.close();
      });
    });
    section.querySelectorAll('.fairytale__nav-group').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        section.querySelectorAll('.fairytale__nav-group').forEach((other) => {
          if (other !== group) other.removeAttribute('open');
        });
      });
    });
    section.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openGroup = section.querySelector('.fairytale__nav-group[open]');
      if (openGroup) {
        openGroup.removeAttribute('open');
        openGroup.querySelector('summary').focus();
      }
    });
    });
  }
  initializeFairytale(document);
  document.addEventListener('shopify:section:load', (event) => initializeFairytale(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.fairytale').forEach((section) => section.fairytaleCleanup?.());
  });
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('.fairytale__nav-group[open]').forEach((group) => {
      if (!group.contains(event.target)) group.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inverawe-newxmasgb-preview"] && !Shopify.designMode) return;
  try {
    
  function initializeChristmasGifts(root) {
    const sections = root.matches?.('[data-gift-preview]') ? [root] : root.querySelectorAll('[data-gift-preview]');
    sections.forEach(section => {
      if (section.dataset.giftReady) return;
      section.dataset.giftReady = 'true';
      const cards = [...section.querySelectorAll('[data-gift-card]')];
      const grid = section.querySelector('[data-gift-grid]');
      const count = section.querySelector('[data-gift-count]');
      const sort = section.querySelector('[data-gift-sort]');
      const empty = section.querySelector('[data-gift-empty]');
      const toolbar = section.querySelector('[data-gift-toolbar]');
      let budget = 'all';
      const update = () => {
        const ordered = [...cards];
        if (sort.value === 'price-asc') ordered.sort((a, b) => Number(a.dataset.giftPrice) - Number(b.dataset.giftPrice));
        if (sort.value === 'price-desc') ordered.sort((a, b) => Number(b.dataset.giftPrice) - Number(a.dataset.giftPrice));
        if (sort.value === 'title') ordered.sort((a, b) => a.dataset.giftName.localeCompare(b.dataset.giftName));
        let visible = 0;
        ordered.forEach(card => {
          const price = Number(card.dataset.giftPrice);
          const withinBudget = budget === 'all' ||
            budget === 'under50' && price < 5000 ||
            budget === '50to100' && price >= 5000 && price <= 10000 ||
            budget === 'over100' && price > 10000;
          card.hidden = !withinBudget;
          if (!card.hidden) visible++;
          grid.append(card);
        });
        count.textContent = count.dataset.countTemplate.replace('__COUNT__', String(visible));
        empty.hidden = visible !== 0;
      };
      section.querySelectorAll('[data-gift-budget]').forEach(button => button.addEventListener('click', () => {
        budget = button.dataset.giftBudget;
        section.querySelectorAll('[data-gift-budget]').forEach(other => {
          other.classList.toggle('is-selected', other === button);
          other.setAttribute('aria-pressed', String(other === button));
        });
        update();
      }));
      sort.addEventListener('change', update);
      toolbar.hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeChristmasGifts(document));
  else initializeChristmasGifts(document);
  document.addEventListener('shopify:section:load', event => initializeChristmasGifts(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inverawe-recipes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseRecipes = () => {
      document.querySelectorAll('[data-fairytale-recipes]').forEach((root) => {
        if (root.dataset.recipesReady === 'true') return;
        root.dataset.recipesReady = 'true';
        const cards = Array.from(root.querySelectorAll('[data-fairytale-recipe-card]'));
        const filters = Array.from(root.querySelectorAll('[data-recipe-filter]'));
        const search = root.querySelector('[data-recipe-search-input]');
        const form = root.querySelector('[data-recipe-search-form]');
        const more = root.querySelector('[data-recipe-more]');
        const empty = root.querySelector('[data-recipe-empty]');
        const status = root.querySelector('[data-recipe-status]');
        const tools = root.querySelector('[data-recipe-tools]');
        const pageSize = Number(root.dataset.pageSize) || 24;
        const normalise = (text) => text.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        let category = 'all';
        let visibleLimit = pageSize;
        const render = () => {
          const terms = normalise(search.value.trim()).split(/\s+/).filter(Boolean);
          const matches = cards.filter((card) => {
            const categoryMatch = category === 'all' || card.dataset.recipeCategory === category;
            const recipeText = normalise(card.dataset.recipeSearch || '');
            return categoryMatch && terms.every((term) => recipeText.includes(term));
          });
          const visible = new Set(matches.slice(0, visibleLimit));
          cards.forEach((card) => { card.hidden = !visible.has(card); });
          empty.hidden = matches.length > 0;
          more.hidden = matches.length <= visibleLimit;
          status.textContent = matches.length === 1 ? root.dataset.singleLabel : root.dataset.countLabel.replace('__SHOWN__', Math.min(visibleLimit, matches.length)).replace('__TOTAL__', matches.length);
        };
        const update = (animate) => {
          visibleLimit = pageSize;
          if (animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(render);
          else render();
        };
        filters.forEach((button) => {
          button.addEventListener('click', () => {
            category = button.dataset.recipeFilter;
            filters.forEach((filter) => {
              const selected = filter === button;
              filter.classList.toggle('is-active', selected);
              filter.setAttribute('aria-pressed', String(selected));
            });
            update(true);
          });
        });
        search.addEventListener('input', () => update(false));
        form.addEventListener('submit', (event) => { event.preventDefault(); update(false); });
        more.addEventListener('click', () => {
          visibleLimit += pageSize;
          render();
        });
        tools.hidden = false;
        render();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseRecipes);
    else initialiseRecipes();
    document.addEventListener('shopify:section:load', initialiseRecipes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  (() => {
    const initialiseRecipeIndexes = () => {
      document.querySelectorAll('[data-recipe-index]').forEach((root) => {
        if (root.dataset.recipeIndexReady === 'true') return;
        root.dataset.recipeIndexReady = 'true';
        const cards = Array.from(root.querySelectorAll('[data-recipe-card]'));
        const filters = Array.from(root.querySelectorAll('[data-recipe-filter]'));
        const moreButton = root.querySelector('[data-recipe-more]');
        const emptyMessage = root.querySelector('[data-recipe-empty]');
        const status = root.querySelector('[data-recipe-status]');
        const pageSize = Number(root.dataset.pageSize) || 24;
        let activeCategory = 'all';
        let visibleLimit = pageSize;
        const render = () => {
          const matchingCards = cards.filter((card) => activeCategory === 'all' || card.dataset.recipeCategory === activeCategory);
          cards.forEach((card) => { card.hidden = true; });
          matchingCards.slice(0, visibleLimit).forEach((card) => { card.hidden = false; });
          emptyMessage.hidden = matchingCards.length !== 0;
          moreButton.hidden = matchingCards.length <= visibleLimit;
          status.textContent = matchingCards.length === 1
            ? root.dataset.singleLabel
            : root.dataset.countLabel
              .replace('__SHOWN__', Math.min(visibleLimit, matchingCards.length))
              .replace('__TOTAL__', matchingCards.length);
        };
        filters.forEach((button) => {
          button.addEventListener('click', () => {
            activeCategory = button.dataset.recipeFilter;
            visibleLimit = pageSize;
            filters.forEach((filterButton) => {
              const selected = filterButton === button;
              filterButton.classList.toggle('is-active', selected);
              filterButton.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
            if (document.startViewTransition) document.startViewTransition(render); else render();
          });
        });
        moreButton.addEventListener('click', () => { visibleLimit += pageSize; render(); });
        render();
      });
    };
    document.addEventListener('DOMContentLoaded', initialiseRecipeIndexes);
    document.addEventListener('shopify:section:load', initialiseRecipeIndexes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanText = (value) => {
      const template = document.createElement('template');
      template.innerHTML = String(value || '');
      return template.content.textContent.trim();
    };

    const money = (cents) =>
      new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
      }).format(Number(cents || 0) / 100);

    const numericId = (gid) => String(gid || '').split('/').pop();

    const element = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };

    document.querySelectorAll('[data-recipe-app]').forEach(async (root) => {
      const source = root.querySelector('[data-recipe-json]');
      const content = root.querySelector('[data-recipe-content]');
      let recipe;

      try {
        recipe = JSON.parse(source.textContent.trim());
      } catch (error) {
        content.setAttribute('aria-busy', 'false');
        root.querySelector('[data-status]').textContent = root.dataset.errorMessage;
        return;
      }

      const title = cleanText(recipe.recipe_title);
      const description = cleanText(recipe.recipe_description);
      const image = root.querySelector('[data-recipe-image]');
      const placeholder = root.querySelector('[data-image-placeholder]');

      if (title) root.querySelector('[data-recipe-title]').textContent = title;
      root.querySelector('[data-recipe-description]').textContent = description;
      root.querySelector('[data-prep-time]').textContent = cleanText(recipe.prep_time) || '—';
      root.querySelector('[data-cook-time]').textContent = cleanText(recipe.cook_time) || '—';
      root.querySelector('[data-servings]').textContent = cleanText(recipe.serving_size) || '—';

      if (recipe.recipe_image) {
        image.src = recipe.recipe_image;
        image.alt = cleanText(recipe.recipe_image_alt_text) || title;
        image.hidden = false;
        placeholder.hidden = true;
      }

      const ingredients = Array.isArray(recipe.recipe_ingredients) ? recipe.recipe_ingredients : [];
      const ingredientList = root.querySelector('[data-ingredients]');
      ingredients.forEach((item) => {
        if (item.type === 'heading') {
          ingredientList.append(
            element('li', 'recipe-app__ingredient recipe-app__ingredient--heading', cleanText(item.heading_text))
          );
          return;
        }
        const ingredient = cleanText(item.ingredient);
        if (ingredient) ingredientList.append(element('li', 'recipe-app__ingredient', ingredient));
      });

      const directions = Array.isArray(recipe.recipe_directions) ? recipe.recipe_directions : [];
      const methodList = root.querySelector('[data-method]');
      directions.forEach((item) => {
        if (item.type === 'heading') {
          methodList.append(
            element('li', 'recipe-app__step recipe-app__step--heading', cleanText(item.heading_text))
          );
          return;
        }
        const direction = cleanText(item.direction);
        if (direction) methodList.append(element('li', 'recipe-app__step', direction));
      });

      content.setAttribute('aria-busy', 'false');

      const productReferences = [];
      const seenHandles = new Set();
      const dedicatedProducts = Array.isArray(recipe.recipe_products) ? recipe.recipe_products : [];

      dedicatedProducts.forEach((selected) => {
        if (!selected || !selected.handle || seenHandles.has(selected.handle)) return;
        seenHandles.add(selected.handle);
        productReferences.push(selected);
      });

      ingredients.forEach((item) => {
        const selected = item.selected_product;
        if (!selected || !selected.handle || seenHandles.has(selected.handle)) return;
        seenHandles.add(selected.handle);
        productReferences.push(selected);
      });

      const productsContainer = root.querySelector('[data-products]');
      const emptyMessage = root.querySelector('[data-empty-products]');
      const addButton = root.querySelector('[data-add-selected]');
      const status = root.querySelector('[data-status]');
      const viewBag = root.querySelector('[data-view-bag]');

      if (!productReferences.length) {
        emptyMessage.hidden = false;
        return;
      }

      const updateAddButton = () => {
        addButton.disabled = !productsContainer.querySelector('input[type="checkbox"]:checked');
      };

      const createProductCard = (product, reference) => {
        const card = element('article', 'recipe-app__product');
        const imageWrap = element('div', 'recipe-app__product-image-wrap');
        const productImage = element('img', 'recipe-app__product-image');
        const imageSource =
          product.featured_image ||
          (Array.isArray(product.images) ? product.images[0] : '') ||
          '';

        if (imageSource) {
          productImage.src = imageSource;
          productImage.alt = product.title || reference.title || '';
          productImage.loading = 'lazy';
          imageWrap.append(productImage);
        }

        const cardContent = element('div', 'recipe-app__product-content');
        const choice = element('label', 'recipe-app__product-choice');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.setAttribute('aria-label', product.title || reference.title || '');

        const choiceText = element('span');
        const productTitle = element(
          'span',
          'recipe-app__product-title',
          product.title || reference.title || ''
        );
        const variants =
          Array.isArray(product.variants) && product.variants.length
            ? product.variants
            : Array.isArray(reference.variants)
              ? reference.variants.map((variant) => ({
                  id: numericId(variant.id),
                  title: variant.title,
                  price: Math.round(Number(variant.price || 0) * 100),
                  available: true
                }))
              : [];
        const initialVariant = variants.find((variant) => variant.available !== false) || variants[0];
        const price = element('span', 'recipe-app__product-price', money(initialVariant?.price));

        choiceText.append(productTitle, price);
        choice.append(checkbox, choiceText);
        cardContent.append(choice);

        if (variants.length > 1) {
          const select = element('select', 'recipe-app__variant');
          select.setAttribute('aria-label', product.title || reference.title || '');
          variants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = variant.id;
            option.textContent = `${variant.title} — ${money(variant.price)}`;
            option.disabled = variant.available === false;
            select.append(option);
          });
          select.addEventListener('change', () => {
            const variant = variants.find((item) => String(item.id) === select.value);
            card.dataset.variantId = select.value;
            price.textContent = money(variant?.price);
          });
          cardContent.append(select);
        }

        card.dataset.variantId = initialVariant?.id || '';

        const quantity = element('div', 'recipe-app__quantity');
        quantity.append(element('span', 'recipe-app__quantity-label', root.dataset.quantityLabel));
        const controls = element('div', 'recipe-app__quantity-controls');
        const decrease = element('button', 'recipe-app__quantity-button', '−');
        decrease.type = 'button';
        decrease.setAttribute(
          'aria-label',
          root.dataset.decreaseLabel.replace('{product}', product.title || reference.title || '')
        );
        const input = element('input', 'recipe-app__quantity-input');
        input.type = 'number';
        input.min = '1';
        input.max = '99';
        input.value = '1';
        input.inputMode = 'numeric';
        input.setAttribute('aria-label', root.dataset.quantityLabel);
        const increase = element('button', 'recipe-app__quantity-button', '+');
        increase.type = 'button';
        increase.setAttribute(
          'aria-label',
          root.dataset.increaseLabel.replace('{product}', product.title || reference.title || '')
        );

        decrease.addEventListener('click', () => {
          input.value = String(Math.max(1, Number(input.value || 1) - 1));
        });
        increase.addEventListener('click', () => {
          input.value = String(Math.min(99, Number(input.value || 1) + 1));
        });
        checkbox.addEventListener('change', updateAddButton);

        controls.append(decrease, input, increase);
        quantity.append(controls);
        cardContent.append(quantity);
        card.append(imageWrap, cardContent);
        return card;
      };

      const productCards = await Promise.all(
        productReferences.map(async (reference) => {
          let product = {
            title: reference.title,
            variants: reference.variants
          };
          try {
            const response = await fetch(`/products/${encodeURIComponent(reference.handle)}.js`);
            if (response.ok) product = await response.json();
          } catch (error) {
            status.textContent = '';
          }
          return createProductCard(product, reference);
        })
      );
      productCards.forEach((card) => productsContainer.append(card));

      addButton.addEventListener('click', async () => {
        const selectedCards = Array.from(
          productsContainer.querySelectorAll('.recipe-app__product')
        ).filter((card) => card.querySelector('input[type="checkbox"]').checked);

        if (!selectedCards.length) {
          status.textContent = root.dataset.selectMessage;
          return;
        }

        const items = selectedCards
          .map((card) => ({
            id: Number(card.dataset.variantId),
            quantity: Number(card.querySelector('.recipe-app__quantity-input').value || 1)
          }))
          .filter((item) => item.id && item.quantity > 0);

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        status.textContent = root.dataset.loadingLabel;
        viewBag.hidden = true;

        try {
          const response = await fetch(root.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('cart');
          status.textContent = root.dataset.addedLabel;
          viewBag.hidden = false;
        } catch (error) {
          status.textContent = root.dataset.errorMessage;
        } finally {
          addButton.removeAttribute('aria-busy');
          updateAddButton();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-recipe-preview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-recipe-preview]').forEach((root) => {
      const heroImage = root.querySelector('[data-recipe-photo-target]');
      if (heroImage && root.dataset.recipePhoto) {
        heroImage.src = root.dataset.recipePhoto;
        heroImage.srcset = '';
      }

      const cards = Array.from(root.querySelectorAll('[data-product-card]'));

      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-product-card]');
          const input = card.querySelector('[data-product-quantity]');
          const nextValue = Number(input.value || 1) + Number(button.dataset.quantityChange);
          input.value = String(Math.min(20, Math.max(1, nextValue)));
        });
      });

      cards.forEach((card) => {
        const addButton = card.querySelector('[data-add-product]');
        const status = card.querySelector('[data-product-status]');
        const viewBag = card.querySelector('[data-view-bag]');

        if (!addButton) return;

        addButton.addEventListener('click', async () => {
          const item = {
            id: Number(card.dataset.variantId),
            quantity: Number(card.querySelector('[data-product-quantity]').value || 1)
          };

          if (!item.id || item.quantity < 1) return;

          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
          status.textContent = 'Adding…';
          viewBag.hidden = true;

          try {
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items: [item] })
            });
            const result = await response.json();
            if (!response.ok) {
              throw new Error(result.description || result.message || 'Unable to add this product.');
            }
            status.textContent = 'Added to bag.';
            viewBag.hidden = false;
          } catch (error) {
            status.textContent = error.message || 'Something went wrong. Please try again.';
          } finally {
            addButton.removeAttribute('aria-busy');
            addButton.disabled = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
